import React, { Component } from "react";

class WhatsApp extends Component {
    render() {
      return (
        <div>
          <a
            id="WhatsApp"
            href="https://wa.me/6581848221"
            target="_blank"
            rel="noopener noreferrer"
          >
            Message us on WhatsApp!
          </a>
        </div>
      );
    }
  }
  
  export default WhatsApp;